module.exports = __webpack_public_path__ + "img/tasks_title.378a3949.svg";